import classNames from 'classnames'
import React from 'react'
import CodiDocumentReportGroup from 'views/Document/components/Codi/CodiDocumentReportGroup'
import {RequiredSystemAdmin} from 'components/RequiredAdmin'
import CodiContext from './CodiContext'
import ManageCodiActions from './ManageCodiActions'
import LoadingBlock from "../../Loading/LoadingBlock";

const CodiManagement = ({ style, className }) => (
  <RequiredSystemAdmin type={"codi_document"}>
    <CodiContext.Consumer>
      {({ item, asyncRowDetail }) => {
        const isLoading = Boolean(asyncRowDetail?.isLoading)
        if (isLoading) {
          return <LoadingBlock />
        }
        return (
          <div
            style={style}
            className={classNames('flex flex-col gap-2', className)}>
            <CodiDocumentReportGroup
              item={item}
              title="error report"
              description="error report description"
            />
            <div className="flex flex-col gap-2">
              <ManageCodiActions
                title="update info book"
                description="update info description"
              />
            </div>
          </div>
        )
      }}
    </CodiContext.Consumer>
  </RequiredSystemAdmin>
)

export default CodiManagement
